export default __webpack_public_path__ + "static/media/white-arrow-down.2ed0e75a.svg";